const controls = document.querySelectorAll('.quantity-controls');
const quantityButtons = document.querySelectorAll('.quantity-controls span');
const inputs = document.querySelectorAll('.quantity-input');

window.onload = function() {

    controls.forEach(element => {
        let input = element.querySelector('.quantity-input')
        let currentValue = parseInt(input.value);
        var minVal = parseInt(input.getAttribute('min'));
        var maxVal = parseInt(input.getAttribute('max'));


        if (currentValue === minVal) {
            element.querySelector('.quantity-controls span[data-operation="decrement"]').classList.add('disabled');
        } else if (currentValue === maxVal) {
            element.querySelector('.quantity-controls span[data-operation="increment"]').classList.add('disabled');
        }

    })
};

quantityButtons.forEach(element => {
    element.onclick = function(e) {

        element.closest(".quantity-controls").querySelectorAll('span[data-operation').forEach(element => {
            element.classList.remove('disabled')
        })

        var parent = element.closest(".quantity-controls");

        var quantityInput = parent.querySelector(".quantity-input");

        var minVal = parseInt(quantityInput.getAttribute('min'));
        var maxVal = parseInt(quantityInput.getAttribute('max'));

        let currentValue = quantityInput.value;

        // try and parse the number
        let num = new Number(currentValue);
        let newNum = 1;

        if (isNaN(num)) {
            return;
        }

        let oldValue = parseInt(quantityInput.dataset.oldValue);

        // if (oldValue == currentValue){
        //     // no change, just return
        //     return;
        // }

        // increment or decrement the number
        let operation = element.getAttribute('data-operation');

        if (operation == "increment") {
            newNum = num + 1;
        } else {
            newNum = num - 1;
        }

        if (newNum <= minVal) {
            newNum = minVal;
            element.classList.add('disabled');
        } else if (newNum >= maxVal) {
            newNum = maxVal;
            element.classList.add('disabled');
        }

        // Set the values
        quantityInput.value = newNum;
        quantityInput.dataset.oldValue = newNum;

        // If the number has changed from before, then raise a change event 
        if (newNum != oldValue) {
            parent.dispatchEvent(new CustomEvent("quantity-control:update"));
        }

    }
})


inputs.forEach(element => {
    element.addEventListener('change', (event) => {

        var parent = element.closest(".quantity-controls");

        parent.querySelectorAll('span[data-operation').forEach(element => {
            element.classList.remove('disabled')
        })

        let currentValue = parseInt(element.value);

        let minVal = parseInt(element.getAttribute('min')) || 0;
        let maxVal = parseInt(element.getAttribute('max')) || 9;

        let newNum = currentValue;

        if (currentValue <= minVal) {
            newNum = minVal;
            parent.querySelector('span[data-operation="decrement"]').classList.add('disabled');
        } else if (currentValue >= maxVal) {
            newNum = maxVal;
            parent.querySelector('span[data-operation="increment"]').classList.add('disabled');
        }

        element.value = newNum;


        let oldValue = parseInt(element.dataset.oldValue);
        if (newNum != oldValue) {
            parent.dispatchEvent(new CustomEvent("quantity-control:update"));
        }
        element.dataset.oldValue = newNum;
    });

    setInputFilter(element, function(value) {
        return /^[0-9][0-9]?$|^100$/.test(value); // Allow digits 
    });
})

function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
        textbox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    });
}